import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import {Link} from "react-router-dom";
import * as moment from "moment";
import {connect}  from  "react-redux";
var yesterday = new Date(Date.now() - 24*60*60*1000);
class BrandEmiReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            reportPermissionsArray:[],
        }
    }
  componentWillMount() {
        this.props.currentMenu("brand_emi_reports");
        }
    componentDidMount() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        let subMenuPermissions = [];
        let reportPermissions = [];
        AllAccessPermissions.map((permissionName, i) => {
            if(permissionName.access_type=='Submenu'){
                subMenuPermissions.push(permissionName.access_name);
            }
            if(permissionName.access_type=='BrandEMI'){
                reportPermissions.push(permissionName.access_name);
            }
        });
        if(subMenuPermissions.includes("brand_emi_reports")===false){
            this.unauthorize_access();
        }
        this.setState({
            reportPermissionsArray:reportPermissions,
            user_id:decoded._id
        });
    }
    unauthorize_access(){
        localStorage.removeItem("usertoken");
        localStorage.removeItem("userPermission");
        this.setState({
            loggedIn: false
        });
        alert("Unauthorized Access");
        window.location.href = "/";
    }

    render() {
        return(

                  <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div className="">
                                <div className="content">
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <div className="card title-card-bottom-space">
                                                <div className="header">
                                                    <h4 className="title">Brand EMI Reports</h4>
                                                    <p className="category"></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="content">
                                    <div className="row">

                                        {this.state.reportPermissionsArray.includes("be_transaction_report")===true?
                                        <div className="col-lg-3 col-xs-6">
                                            <div className="card report-dash">
                                                <div className="content text-center">
                                                    <Link className=""   to="/admin/brand-emi-transaction-report">
                                                        <div className="report-thumbs-ico">
                                                            <div className="icon-big text-center folder-icon">
                                                                <i className="fa fa-folder-o"></i>
                                                            </div>
                                                            <h5>Transaction Report</h5>
                                                            {/* <p className="text-muted">Last updated : {moment(yesterday).format('D MMM YYYY HH:mm:ss')}</p> */}
                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div> :null}
                                        {this.state.reportPermissionsArray.includes("be_api_log_report")===true?
                                        <div className="col-lg-3 col-xs-6">
                                            <div className="card report-dash">
                                                <div className="content text-center">
                                                    <Link className="" to="/admin/brand-emi-api-log-report">
                                                        <div className="report-thumbs-ico">
                                                            <div className="icon-big text-center folder-icon">
                                                                <i className="fa fa-folder-o"></i>
                                                            </div>
                                                            <h5>API Log Report</h5>
                                                            {/*<p className="text-muted"> 2020-03-28 00:00:00</p>*/}
                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div> : null }
                                        {this.state.reportPermissionsArray.includes("be_scheme_enablement_report")===true?
                                        <div className="col-lg-3 col-md-4 col-sm-3 col-xs-6 ">
                                            <div className="card report-dash">
                                                <div className="content text-center">
                                                    <Link className=""   to="/admin/scheme-enablement-report/">
                                                        <div className="report-thumbs-ico">
                                                            <div className="icon-big text-center folder-icon">
                                                                <i className="fa fa-folder-o"></i>
                                                            </div>
                                                            <h5>Scheme Enablement Report</h5>
                                                            {/*<p className="text-muted">Last updated : 2020-03-28 00:00:00</p>*/}
                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div> : null }
                                    </div>
                                    <div className="row">


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

const mapDispatchToProps = (dispatch) =>{
  return {
  currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
  }
}
export default connect(null,mapDispatchToProps)(BrandEmiReport);